import { motion } from "framer-motion";
import { VALUES } from "../../lib/data";

export default function ValuesSection() {
  return (
    <section
      data-testid="values-section"
      className="relative py-24 md:py-36 px-6 md:px-12 max-w-[1440px] mx-auto"
    >
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-white/50">
            <span className="h-px w-8 bg-[#C48F56]" />
            Cosa ci guida
          </div>
          <h2 className="mt-6 font-display text-5xl md:text-6xl tracking-tightest leading-[0.95]">
            Un approccio <span className="text-[#C48F56]">verticale.</span>
          </h2>
          <p className="mt-6 text-white/60 leading-relaxed">
            La gestione diretta di tutte le fasi della catena del valore —
            immobiliare, progettuale, operativa — assicura rapidità decisionale
            e redditività sostenibile nel lungo periodo.
          </p>
        </div>
        <div className="lg:col-span-8 space-y-4">
          {VALUES.map((v, i) => (
            <motion.div
              key={v.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.05 }}
              transition={{
                duration: 0.7,
                delay: i * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="group relative rounded-2xl border border-white/10 bg-[#0F0F14] p-8 md:p-10 beam hover:border-white/20 transition-colors"
            >
              <div className="flex items-baseline gap-6">
                <span className="font-mono text-[11px] text-white/30">
                  0{i + 1}
                </span>
                <div>
                  <h3 className="font-display text-3xl md:text-4xl tracking-tight">
                    {v.title}
                  </h3>
                  <p className="mt-4 text-white/60 leading-relaxed max-w-2xl">
                    {v.text}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
